import cx from "classnames";
import { motion } from "framer-motion";

export type AnimatedTabButtonProps = {
  icon: React.ReactNode;
  title: string;
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
  buttonClass?: string;
  selectedTabColor?: string;
  unselectedTabColor?: string;
}

/* 
 * Variants for the animated tab bar that shows the active feature.
 * When active, the active bar color fills in the width of the tab.
 */

const activeBarVariants = {
  active: { width: '100%', opacity: 1, transition: { duration: 0.2 } },
  inactive: { width: 0, opacity: 0, transition: { duration: 0.1 } },
};

const AnimatedTabButton = ({
  icon,
  title,
  isActive,
  setIsActive,
  buttonClass,
  selectedTabColor = 'bg-violet-600',
  unselectedTabColor = 'bg-violet-800',
}: AnimatedTabButtonProps) => {
  return (
    <div
      className="max-w-[205px] w-full relative flex flex-col items-center"
    >
      <button
        className={cx(`block button button-size-medium`, buttonClass, {
          active: isActive,
        })}
        onClick={() => setIsActive(!isActive)}
      >
        <div className="flex items-center gap-1">
          {icon}
          <div className="text-caption1">{title}</div>
        </div>
      </button>
      <div
        className={cx('h-[6px] mt-[12px] relative w-full rounded-10 overflow-hidden', unselectedTabColor
        )}
      >
        <motion.div
          initial={{ width: 0, opacity: 0 }}
          variants={activeBarVariants}
          animate={isActive ? "active" : "inactive"}
          className={cx("absolute inset-0 h-[6px] rounded-10 overflow-hidden", selectedTabColor)}
        />
      </div>
    </div>

  )
}

export default AnimatedTabButton;
